export default "__VITE_ASSET__46d7e9b5__"